module.exports = __webpack_public_path__ + "static/team_02-5bb01537c2686d9d689245c933da99bd.png";